// Path: frontend/src/pages/admin/components/chat-records/SalesMessagesTable.tsx

import React from 'react';
import { type SalesMessage } from '../../../../lib/apis_chatmsg';

const formatDate = (dateStr: string): string => {
  const date = new Date(dateStr);
  return date.toLocaleString('zh-CN', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit'
  });
};

const sortSalesMessages = (messages: SalesMessage[]): SalesMessage[] => {
  return [...messages].sort((a, b) => {
    return new Date(b.created_at).getTime() - new Date(a.created_at).getTime();
  });
};

interface SalesMessagesTableProps {
  messages: SalesMessage[];
}

const SalesMessagesTable: React.FC<SalesMessagesTableProps> = ({ messages }) => {
  const sortedMessages = sortSalesMessages(messages);

  if (sortedMessages.length === 0) {
    return (
      <div className="text-gray-400 text-sm italic p-4 text-center">
        暂无聊天记录
      </div>
    );
  }

  return (
    <div className="overflow-x-auto">
      <table className="min-w-full divide-y divide-gray-200">
        <thead className="bg-gray-50">
          <tr>
            <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider w-24">
              消息ID
            </th>
            <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
              内容
            </th>
            <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider w-44">
              时间
            </th>
          </tr>
        </thead>
        <tbody className="bg-white divide-y divide-gray-200">
          {sortedMessages.map((msg, idx) => (
            <tr key={`${msg.message_id}-${idx}`} className="hover:bg-gray-50">
              <td className="px-4 py-3 whitespace-nowrap text-sm text-gray-600">
                {msg.message_id}
              </td>
              <td className="px-4 py-3 text-sm text-gray-800 max-w-md">
                <div className="truncate" title={msg.content}>
                  {msg.content}
                </div>
              </td>
              <td className="px-4 py-3 whitespace-nowrap text-sm text-gray-500">
                {formatDate(msg.created_at)}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default SalesMessagesTable;
